import { useDispatch, useSelector } from 'react-redux'
import { getKeyByTypePrefix } from '../../../store/helper'
import { handleScrollActiveRow, selectRowGroup } from '../../../store/slice'
import BaseCell from './BaseCell'
import classes from './classes.module.scss'
import { isOdd } from './helper'
import withCustomTd from './withCustomTd'

const RowGroup = ({
  rowId,
  schema,
  typePrefix,
  groupRowIndex,
  isDynamicReport,
}) => {
  const dispatch = useDispatch()
  const isFirstGroupRow = groupRowIndex === 0

  const rowGroup = useSelector(selectRowGroup(rowId, typePrefix))

  const handleColor = () => {
    if (isFirstGroupRow && !isDynamicReport) return '#C8E3FF'

    if (isOdd(groupRowIndex)) return '#F9F9F9'

    return ''
  }

  const onClick = () => {
    dispatch(
      handleScrollActiveRow({
        rowId,
        keyTypePrefix: getKeyByTypePrefix(typePrefix),
      }),
    )
  }

  const renderContent = (rowIndex, totalRowInGroup) => {
    return schema.map(({ colId }, colIndex) => {
      const Cell = withCustomTd({
        rowIndex,
        colIndex,
        rowId,
        colId,
        typePrefix,
        isDynamicReport,
      })(BaseCell)

      return (
        <Cell
          key={colIndex}
          isFirstGroupRow={isFirstGroupRow}
          rowSpanFirstCell={totalRowInGroup}
          backgroundColor={handleColor()}
        />
      )
    })
  }

  return rowGroup.map((_, rowIndex, arr) => {
    return (
      <tr key={rowIndex} className={classes.mouseOverRow} onClick={onClick}>
        {renderContent(rowIndex, arr.length)}
      </tr>
    )
  })
}

export default RowGroup
